import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Glasses } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PageHead } from '../components/PageHead';
import './CollectionPage.css';

export const MonturesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="collection-page">
      <PageHead
        title="Sélection de Montures – Lunetterie du Russey | Made in France"
        description="Montures françaises Origine France Garantie : Roussilhe, Lafont, Vuillet Vega, In'bo, Jullien. Opticien indépendant au Russey (25210), Haut-Doubs."
        image="/banner-montures.jpg"
      />
      <div className="collection-page-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
          className="back-button"
        >
          <ArrowLeft size={20} />
          Retour
        </Button>
      </div>

      <div className="collection-page-container">
        <div className="collection-banner">
          <img src="/banner-montures.jpg" alt="Sélection de montures françaises Origine France Garantie – Lunetterie du Russey" />
          <div className="collection-banner-overlay">
            <div className="collection-hero-icon">
              <Glasses size={48} />
            </div>
            <h1 className="collection-hero-title">Sélection de Montures</h1>
            <p className="collection-hero-intro">
              Parmi une collection composée essentiellement de montures Made in France, 
              retrouvez à la Lunetterie du Russey des marques Origine France Garantie.
            </p>
          </div>
        </div>

        <div className="brands-content">
          {/* Roussilhe */}
          <div className="brand-section">
            <div className="brand-content-wrapper">
              <div className="brand-text">
                <h2 className="brand-title">Roussilhe</h2>
                <p className="brand-description">
                  Déclinée sur plusieurs collections (Pop, Millésime, Bonnie et Origine), 
                  la manufacture Roussilhe est très bien représentée au Russey.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/roussilhe.jpg" alt="Montures Roussilhe – collections Pop, Millésime, Bonnie et Origine, disponibles au Russey" />
              </div>
            </div>
          </div>

          {/* Lafont */}
          <div className="brand-section">
            <div className="brand-content-wrapper reverse">
              <div className="brand-text">
                <h2 className="brand-title">Lafont</h2>
                <p className="brand-description">
                  Marque parisienne réputée pour sa collection enfant. Elle étonnera aussi 
                  sur sa collection adulte par une sélection de plaques d'acétate exclusives.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/lafont.jpg" alt="Montures Lafont Paris – lunettes adulte et enfant en acétate, disponibles à la Lunetterie du Russey" />
              </div>
            </div>
          </div>

          {/* Vuillet Vega */}
          <div className="brand-section">
            <div className="brand-content-wrapper">
              <div className="brand-text">
                <h2 className="brand-title">Vuillet Vega</h2>
                <p className="brand-description">
                  Lunetier Morézien depuis 8 générations, Vuillet Vega est inscrite au 
                  répertoire des Entreprises du Patrimoine Vivant. Présentées récemment à 
                  l'Élysée, leurs lunettes, du plus coloré au plus classique, sauront vous séduire.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/vuillet-vega.jpg" alt="Montures Vuillet Vega – lunetier Morézien depuis 8 générations, Entreprise du Patrimoine Vivant" />
              </div>
            </div>
          </div>

          {/* In'bo */}
          <div className="brand-section">
            <div className="brand-content-wrapper reverse">
              <div className="brand-text">
                <h2 className="brand-title">In'bo</h2>
                <p className="brand-description">
                  Start-up de la lunetterie, cette société vosgienne a su trouver sa clientèle 
                  parmi les amateurs de nature et d'écologie en proposant des paires de lunettes en bois.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/inbo.jpg" alt="Montures In'bo – lunettes en bois écologiques, marque vosgienne disponible au Russey" />
              </div>
            </div>
          </div>

          {/* Jullien */}
          <div className="brand-section">
            <div className="brand-content-wrapper">
              <div className="brand-text">
                <h2 className="brand-title">Jullien</h2>
                <p className="brand-description">
                  Institution Jurassienne depuis des décennies, la maison Henry Jullien a laissé 
                  la main en 2021 à des repreneurs italiens. Ceux-ci ont souhaité conserver les 
                  valeurs chères à la marque, notamment le doublé or laminé, encore entièrement 
                  réalisé à Lons-le-Saunier.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/jullien.jpg" alt="Montures Henry Jullien – doublé or laminé fabriqué à Lons-le-Saunier, disponibles au Russey" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};